import axios from 'axios';

export default function (options: { headers?: any } = {}) {
  const { headers = {} } = options;

  const aemAxiosClient = axios.create({
    headers: { ...headers },
  });

  // Request interceptor
  aemAxiosClient.interceptors.request.use(
    function (config) {
      config.headers = { ...config.headers };
      return config;
    },
    function (error) {
      return Promise.reject(error);
    },
  );

  aemAxiosClient.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      return Promise.reject(error);
    },
  );

  return aemAxiosClient;
}
